module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/749e41931a474a1320cf2b153789c67c.gif";